<template>
    <div class="query-page-wrapper">
        <div class="query-main" :class="{ 'center-mode': !showResult }">
            <!-- 左侧区域 -->
            <div class="query-left">
                <div class="query-header">
                    <div class="header-icon">
                        <i class="el-icon-money"></i>
                    </div>
                    <h1>权益金查询系统</h1>
                    <p>查询账户余额与交易流水记录</p>
                </div>

                <div class="query-card">
                    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
                        <el-tab-pane label="余额查询" name="balance">
                            <span slot="label">
                                <i class="el-icon-bank-card"></i> 余额查询
                            </span>
                        </el-tab-pane>
                        <el-tab-pane label="流水记录" name="record">
                            <span slot="label">
                                <i class="el-icon-document"></i> 流水记录
                            </span>
                        </el-tab-pane>
                    </el-tabs>

                    <!-- 余额查询 -->
                    <div v-show="activeTab === 'balance'" class="query-content">
                        <div class="search-form">
                            <el-input
                                v-model="balancePhone"
                                placeholder="请输入手机号码"
                                maxlength="11"
                                clearable
                                prefix-icon="el-icon-mobile-phone"
                                @keyup.enter.native="searchBalance">
                            </el-input>
                            <el-button
                                type="primary"
                                icon="el-icon-search"
                                :loading="balanceLoading"
                                @click="searchBalance">
                                查询
                            </el-button>
                        </div>

                        <el-alert
                            v-if="balanceError"
                            :title="balanceError"
                            type="error"
                            show-icon
                            closable
                            @close="balanceError = ''">
                        </el-alert>

                        <!-- 查询记录 -->
                        <div class="history-section" v-if="balanceHistory.length > 0">
                            <div class="history-title">
                                <i class="el-icon-time"></i> 查询记录
                                <el-button type="text" size="mini" @click="clearHistory('balance')">清空</el-button>
                            </div>
                            <div class="history-tip">系统只保留最近20条查询记录</div>
                            <div class="history-list">
                                <div
                                    class="history-item"
                                    v-for="(item, index) in balanceHistory"
                                    :key="index"
                                    @click="quickSearch('balance', item)">
                                    <div class="history-phone">{{ item.phone }}</div>
                                    <div class="history-time">{{ item.time }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 流水记录 -->
                    <div v-show="activeTab === 'record'" class="query-content">
                        <div class="search-form">
                            <el-input
                                v-model="recordPhone"
                                placeholder="请输入手机号码"
                                maxlength="11"
                                clearable
                                prefix-icon="el-icon-mobile-phone"
                                @keyup.enter.native="searchRecord">
                            </el-input>
                        </div>
                        <div class="search-form">
                            <el-date-picker
                                v-model="recordStartDate"
                                type="datetime"
                                placeholder="开始时间"
                                value-format="yyyyMMddHHmmss"
                                format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            <el-date-picker
                                v-model="recordEndDate"
                                type="datetime"
                                placeholder="结束时间"
                                value-format="yyyyMMddHHmmss"
                                format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                            <el-button
                                type="primary"
                                icon="el-icon-search"
                                :loading="recordLoading"
                                @click="searchRecord">
                                查询
                            </el-button>
                        </div>

                        <el-alert
                            v-if="recordError"
                            :title="recordError"
                            type="error"
                            show-icon
                            closable
                            @close="recordError = ''">
                        </el-alert>

                        <!-- 查询记录 -->
                        <div class="history-section" v-if="recordHistory.length > 0">
                            <div class="history-title">
                                <i class="el-icon-time"></i> 查询记录
                                <el-button type="text" size="mini" @click="clearHistory('record')">清空</el-button>
                            </div>
                            <div class="history-tip">系统只保留最近20条查询记录</div>
                            <div class="history-list">
                                <div
                                    class="history-item"
                                    v-for="(item, index) in recordHistory"
                                    :key="index"
                                    @click="quickSearch('record', item)">
                                    <div class="history-main">
                                        <span class="history-phone">{{ item.phone }}</span>
                                        <span class="history-date" v-if="item.startDate || item.endDate">
                                            {{ item.startDate || '...' }} ~ {{ item.endDate || '...' }}
                                        </span>
                                    </div>
                                    <div class="history-time">{{ item.time }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 右侧区域 -->
            <div class="query-right" v-if="showResult">
                <div class="result-header">
                    <i class="el-icon-document-checked"></i>
                    <span>接口返回数据 (JSON)</span>
                    <el-button type="primary" size="mini" icon="el-icon-document-copy" @click="copyResult">
                        复制
                    </el-button>
                    <el-button type="text" icon="el-icon-close" @click="closeResult">
                        关闭
                    </el-button>
                </div>
                <div class="result-body">
                    <pre class="json-code"><code v-html="formatJson(currentResult)"></code></pre>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getYdApiBalanceData, getYdApiBalanceRecordList } from "../../api/api";

export default {
    name: "EquityBalanceQuery",
    data() {
        return {
            activeTab: "balance",
            balancePhone: "",
            balanceLoading: false,
            balanceError: "",
            balanceResult: null,
            recordPhone: "",
            recordStartDate: "",
            recordEndDate: "",
            recordLoading: false,
            recordError: "",
            recordResult: null,
            balanceHistory: [],
            recordHistory: [],
        };
    },
    computed: {
        showResult() {
            return this.balanceResult !== null || this.recordResult !== null;
        },
        currentResult() {
            return this.activeTab === 'balance' ? this.balanceResult : this.recordResult;
        }
    },
    created() {
        this.loadHistory();
        // 流水记录默认赋值最近一年的查询日期
        this.initRecordDefaultDate();
    },
    methods: {
        loadHistory() {
            const balanceHistory = localStorage.getItem('equityBalanceQuery_balanceHistory');
            const recordHistory = localStorage.getItem('equityBalanceQuery_recordHistory');
            this.balanceHistory = balanceHistory ? JSON.parse(balanceHistory) : [];
            this.recordHistory = recordHistory ? JSON.parse(recordHistory) : [];
        },

        // 流水记录默认日期：开始=一年前今天 00:00:00，结束=今天 23:59:59
        // 格式与 date-picker 的 value-format 保持一致（yyyyMMddHHmmss）
        initRecordDefaultDate() {
            const pad = (n) => String(n).padStart(2, '0');
            const format = (date, endOfDay = false) => {
                const y = date.getFullYear();
                const m = pad(date.getMonth() + 1);
                const d = pad(date.getDate());
                const h = endOfDay ? '23' : '00';
                const min = endOfDay ? '59' : '00';
                const s = endOfDay ? '59' : '00';
                return `${y}${m}${d}${h}${min}${s}`;
            };

            const now = new Date();
            const start = new Date(now);
            start.setFullYear(now.getFullYear() - 1);

            this.recordStartDate = format(start, false);
            this.recordEndDate = format(now, true);
        },

        saveHistory(type, data) {
            const history = type === 'balance' ? this.balanceHistory : this.recordHistory;
            const storageKey = type === 'balance' ? 'equityBalanceQuery_balanceHistory' : 'equityBalanceQuery_recordHistory';

            // 根据手机号检查是否已存在记录
            const existIndex = history.findIndex(item => item.phone === data.phone);
            if (existIndex > -1) {
                history.splice(existIndex, 1);
            }

            // 添加到最前面
            history.unshift(data);

            // 最多保存20条
            if (history.length > 20) {
                history.pop();
            }

            localStorage.setItem(storageKey, JSON.stringify(history));
        },

        clearHistory(type) {
            if (type === 'balance') {
                this.balanceHistory = [];
                localStorage.removeItem('equityBalanceQuery_balanceHistory');
            } else {
                this.recordHistory = [];
                localStorage.removeItem('equityBalanceQuery_recordHistory');
            }
        },

        quickSearch(type, item) {
            if (type === 'balance') {
                this.balancePhone = item.phone;
                this.searchBalance();
            } else {
                this.recordPhone = item.phone;
                this.recordStartDate = item.startDate || '';
                this.recordEndDate = item.endDate || '';
                this.searchRecord();
            }
        },

        handleTabClick(tab) {
            this.activeTab = tab.name;
        },

        validatePhone(phone) {
            return /^1[3-9]\d{9}$/.test(phone);
        },

        closeResult() {
            this.balanceResult = null;
            this.recordResult = null;
        },

        copyResult() {
            const text = JSON.stringify(this.currentResult, null, 2);
            navigator.clipboard.writeText(text).then(() => {
                this.$message.success('复制成功');
            }).catch(() => {
                // 降级方案
                const textarea = document.createElement('textarea');
                textarea.value = text;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
                this.$message.success('复制成功');
            });
        },

        searchBalance() {
            if (!this.balancePhone) {
                this.balanceError = "请输入手机号码";
                return;
            }

            if (!this.validatePhone(this.balancePhone)) {
                this.balanceError = "请输入正确的手机号码";
                return;
            }

            this.balanceError = "";
            this.balanceLoading = true;
            this.balanceResult = null;

            getYdApiBalanceData({ phone: this.balancePhone })
                .then((res) => {
                    this.balanceLoading = false;
                    this.balanceResult = res;
                    // 保存查询记录
                    this.saveHistory('balance', {
                        phone: this.balancePhone,
                        time: this.formatDateTime(new Date())
                    });
                })
                .catch((err) => {
                    this.balanceLoading = false;
                    this.balanceError = "网络错误，请稍后重试";
                    console.error("查询失败:", err);
                });
        },

        searchRecord() {
            if (!this.recordPhone) {
                this.recordError = "请输入手机号码";
                return;
            }

            if (!this.validatePhone(this.recordPhone)) {
                this.recordError = "请输入正确的手机号码";
                return;
            }

            this.recordError = "";
            this.recordLoading = true;
            this.recordResult = null;

            const params = {
                phone: this.recordPhone,
            };
            if (this.recordStartDate) {
                params.startDate = this.recordStartDate;
            }
            if (this.recordEndDate) {
                params.endDate = this.recordEndDate;
            }

            getYdApiBalanceRecordList(params)
                .then((res) => {
                    this.recordLoading = false;
                    this.recordResult = res;
                    // 保存查询记录
                    this.saveHistory('record', {
                        phone: this.recordPhone,
                        startDate: this.recordStartDate || '',
                        endDate: this.recordEndDate || '',
                        time: this.formatDateTime(new Date())
                    });
                })
                .catch((err) => {
                    this.recordLoading = false;
                    this.recordError = "网络错误，请稍后重试";
                    console.error("查询失败:", err);
                });
        },

        formatDateTime(date) {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            const h = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${d} ${h}:${min}`;
        },

        formatJson(data) {
            const json = JSON.stringify(data, null, 2);
            return this.syntaxHighlight(json);
        },

        syntaxHighlight(json) {
            json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            return json.replace(
                /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
                function (match) {
                    let cls = "json-number";
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = "json-key";
                        } else {
                            cls = "json-string";
                        }
                    } else if (/true|false/.test(match)) {
                        cls = "json-boolean";
                    } else if (/null/.test(match)) {
                        cls = "json-null";
                    }
                    return '<span class="' + cls + '">' + match + "</span>";
                }
            );
        },
    },
};
</script>

<style scoped>
.query-page-wrapper {
    height: 100%;
    background: linear-gradient(135deg, #EEF2FF 0%, #F5F3FF 100%);
    overflow: hidden;
}

.query-main {
    height: 100%;
    display: flex;
    padding: 40px;
    box-sizing: border-box;
    gap: 30px;
}

.query-main.center-mode {
    justify-content: center;
}

/* 左侧区域 */
.query-left {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.query-header {
    text-align: center;
    margin-bottom: 30px;
}

.header-icon {
    width: 64px;
    height: 64px;
    background: linear-gradient(135deg, #4F46E5 0%, #7C3AED 100%);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.3);
}

.header-icon i {
    font-size: 32px;
    color: white;
}

.query-header h1 {
    font-size: 24px;
    font-weight: 700;
    color: #1E293B;
    margin-bottom: 8px;
}

.query-header p {
    font-size: 14px;
    color: #64748B;
}

.query-card {
    background: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
    padding: 20px;
    width: 540px;
}

.query-content {
    padding-top: 10px;
}

.search-form {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    align-items: center;
}

.search-form .el-input {
    flex: 1;
}

.search-form .el-date-editor {
    width: 180px;
}

/* 查询记录样式 */
.history-section {
    margin-top: 20px;
    border-top: 1px solid #E2E8F0;
    padding-top: 15px;
    max-height: 280px;
    display: flex;
    flex-direction: column;
}

.history-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    color: #64748B;
    margin-bottom: 8px;
    flex-shrink: 0;
}

.history-title i {
    margin-right: 5px;
}

.history-tip {
    font-size: 12px;
    color: #94A3B8;
    margin-bottom: 10px;
    flex-shrink: 0;
}

.history-list {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
}

.history-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: #F8FAFC;
    border-radius: 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s;
}

.history-item:hover {
    background: #EEF2FF;
}

.history-phone {
    font-size: 14px;
    color: #1E293B;
    font-weight: 500;
}

.history-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.history-date {
    font-size: 12px;
    color: #94A3B8;
}

.history-time {
    font-size: 12px;
    color: #94A3B8;
}

/* 右侧区域 */
.query-right {
    flex: 1;
    min-width: 0;
    background: #FFFFFF;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.result-header {
    display: flex;
    align-items: center;
    padding: 14px 20px;
    background: #F8FAFC;
    border-bottom: 1px solid #E2E8F0;
    flex-shrink: 0;
}

.result-header i {
    font-size: 18px;
    color: #4F46E5;
    margin-right: 8px;
}

.result-header span {
    font-size: 14px;
    font-weight: 600;
    color: #1E293B;
    flex: 1;
}

.result-header .el-button {
    margin-left: 10px;
}

.result-body {
    flex: 1;
    overflow: hidden;
}

.json-code {
    margin: 0;
    padding: 20px;
    background: #1E293B;
    color: #E2E8F0;
    font-family: "Monaco", "Menlo", "Ubuntu Mono", "Consolas", monospace;
    font-size: 13px;
    line-height: 1.7;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
}

/* JSON Syntax Highlighting */
.json-code >>> .json-key {
    color: #7DD3FC;
}

.json-code >>> .json-string {
    color: #86EFAC;
}

.json-code >>> .json-number {
    color: #FCD34D;
}

.json-code >>> .json-boolean {
    color: #F9A8D4;
}

.json-code >>> .json-null {
    color: #94A3B8;
}

/* Responsive */
@media (max-width: 1000px) {
    .query-main {
        flex-direction: column;
        padding: 20px;
        overflow-y: auto;
    }

    .query-main.center-mode {
        justify-content: flex-start;
    }

    .query-left {
        width: 100%;
    }

    .query-card {
        width: 100%;
    }

    .query-right {
        flex: none;
        height: 400px;
    }

    .search-form {
        flex-wrap: wrap;
    }

    .search-form .el-date-editor {
        flex: 1;
        min-width: 150px;
    }
}
</style>
